import { DBRoleConstants } from '../../_constants';

export function DBRole(state = {}, action) {
    switch (action.type) {
        case DBRoleConstants.FETCHING:
            return {
                ...state,
                fetching: true
            };
        case DBRoleConstants.FETCHED:
            return {
                ...state,
                fetching: false
            };
        case DBRoleConstants.GET_DBROLE:
            return {
                ...state,
                DBRole: action.DBRole,
                DBRoleSelection: true
            };
        default:
            return state;
    }
}